import React, { useState } from "react";
import { Container, Typography, Card, CardContent } from "@mui/material";
import "./SellYourMusicThirdSection.scss";
import ArtistImage from "../../../assets/Images/Sell your music/RD Parmar.jpg";
import Ajaypic from "../../../assets/Images/Sell your music/ajay pic.jpg";

import RDImg from "../../../assets/Images/Sell your music/RHM.jfif";
import HDImg from "../../../assets/Images/Sell your music/HMK.jfif";
import ArImg from "../../../assets/Images/Sell your music/A R Stevenson.jpg";
import DJMeddy from "../../../assets/Images/Sell your music/DJ maddy.jpg";
import spotifyIcon from "../../../assets/Images/Sell your music/spotify.svg";
import instagramIcon from "../../../assets/Images/Sell your music/instagram.svg";
import youtubeIcon from "../../../assets/Images/Sell your music/Youtube.svg";
import facebookIcon from "../../../assets/Images/Sell your music/fb.svg";

const artists = [
    {
        id: 1,
        name: "Ajay",
        description:
            "Partnering with FM Digital Official as an exclusive artist has been a game-changer. Their team’s support has made the distribution process seamless and efficient. For me, expanding my reach and engaging with my audience is essential, and FM Digital Official has facilitated this with ease. Their direct distribution platform, combined with their dedication to promoting independent artists, has truly set them apart.",
        image: Ajaypic,
        links: {
            spotify: '',
            instagram: 'https://www.instagram.com/fmdigitalofficial/ _its_ajayyy/',
            facebook: 'https://www.facebook.com/FMDigital2/ ajay.chhabra.1426',
            youtube: 'https://www.youtube.com/@fm_digital @FMFEELmusic',
        },
        background: "linear - gradient(180deg, rgb(187, 135, 255), #ffff)",
    },
    {
        id: 2,
        name: "DJ Maddy",
        description:
            "Working with FM Digital Official has been incredibly smooth, thanks to the outstanding support from their team. As an independent artist, having a seamless distribution process is crucial for expanding our reach and connecting with our audience. FM Digital Official has made this entire process exceptionally easy. They provide a direct distribution platform and actively support and promote the independent artist community.",
        image: DJMeddy,
        links: {
            spotify:
                "https://open.spotify.com/artist/6sbhAl39ga8unQVaePX558?si=WwHfIOg3QNupr1N58Rq6kQ",
            instagram: "https://www.instagram.com/manishatreja/",
            facebook: "https://www.facebook.com/manish.atreja",
            youtube: "https://www.youtube.com/channel/UCRYqJ7XJTaqy0Nl91wzCIHw",
        },
        background: "linear-gradient(180deg, rgb(102, 255, 219), #ffff)",
    },
    {
        id: 3,
        name: "Ramesh Hosanna Ministries",
        description:
            "I'm thrilled to release my debut track through FM Digital Official. The team is incredibly open and personal, showing genuine care for my music. As an artist, it's invaluable to work with people who truly care about your work.",
        image: RDImg,
        links: {
            spotify:
                "https://open.spotify.com/artist/1XaWLxLjDeXKZx4LmHsQQf?si=wiog6UoJRSOEzuyey1Y8PQ",
            instagram:
                "https://www.instagram.com/ramesh_hosanna_ministries/",
            facebook: "https://www.facebook.com/RameshHosannaMinistries",
            youtube: "https://www.youtube.com/@RameshHosannaMinistries",
        },

        background: "linear-gradient(180deg, rgb(240, 255, 158), #ffff)",
    },
    {
        id: 4,
        name: "Hosanna Ministries Kurnool",
        description:
            "Partnering with Almost Famous and FM Digital Official has been a thrilling journey, showcasing how blending cultures can forge fresh, boundary-pushing sounds. Collaborating with FM Digital Official felt like joining a global, borderless community.",
        image: HDImg,
        links: {
            spotify:
                "https://open.spotify.com/artist/1wAnjuaT1lZ9ULjRJIq3rX?si=QSN7QRICRY--LL-3IKJg0Q",
            instagram:
                "https://www.instagram.com/hosannaministries_kurnool/",
            facebook: "https://www.facebook.com/hosannamandhirkurnool",
            youtube: "https://www.youtube.com/@HOSANNAMINISTRIESKURNOOL",
        },
        background: "linear - gradient(180deg, rgb(187, 135, 255), #ffff)",
    },
    {
        id: 5,
        name: "RD Parmar",
        description:
            "Independent music is about authenticity and being true to yourself, and FM Digital Official embodies that same spirit. They’ve been incredibly supportive throughout the entire process, from start to finish, helping me every step of the way.",
        image: ArtistImage,
        links: {
            spotify:
                "https://open.spotify.com/artist/50XMsQFXiwEDaadpgdBWWT?si=NyMVDsE_SG6zR43VhUKBiw",
            instagram:
                "https://www.instagram.com/rdparmarofficial",
            facebook: "https://www.facebook.com/rdparmarofficial",
            youtube: "https://www.youtube.com/@Rdparmar",
        },
        background: "linear-gradient(180deg, rgb(102, 255, 219), #ffff)",
    },
    {
        id: 6,
        name: "Symphony Music",
        description:
            "Collaborating with FM Digital Official has been incredible. Their commitment to supporting independent artists is authentic, providing us with the freedom to stay true to ourselves. It’s great to have a team that genuinely supports your music.",
        image: ArImg,
        links: {
            spotify:
                "https://open.spotify.com/artist/1g8AZip8hKwYjgEtdH2Qv2?si=h-U8TZRjTQ-Vt6gAq-TdoA",
            instagram: "https://www.instagram.com/a.r.stevenson",
            facebook:
                "https://www.facebook.com/profile.php?id=61550673695608&mibextid=haYZDX",
            youtube: "https://www.youtube.com/@SYMPHONYMUSIC",
        },
        background: "linear-gradient(180deg, rgb(240, 255, 158), #ffff)",
    },
];

function SellYourMusicThirdSection() {
    const [activeArtist, setActiveArtist] = useState(1); // Default to the first artist open

    const handleArtistClick = (id) => {
        setActiveArtist(activeArtist === id ? null : id);
    };

    return (
        <div className="sell-your-third-section">
            <Container className="trusted-content">
                <Typography variant="h4" className="trusted-heading">
                    Trusted by Artists
                </Typography>

                <div className="artist-showcase">
                    {artists.map((artist) => (
                        <div
                            key={artist.id}
                            className={`color-bar-container ${activeArtist === artist.id ? "active" : ""
                                }`}
                            onClick={() => handleArtistClick(artist.id)}>
                            <Card
                                className={`artist-card ${activeArtist === artist.id ? "expanded" : ""
                                    }`}
                                style={{ background: artist.background }}>
                                <div className="artist-details">
                                    <img
                                        src={artist.image}
                                        alt={artist.name}
                                        className="artist-image"
                                    />
                                    <CardContent
                                        sx={{ padding: "4px", display: "list-item" }}
                                        className="card-content">
                                        <Typography className="CardHeading" variant="h6">
                                            {artist.name}
                                        </Typography>
                                        {activeArtist === artist.id ? (
                                            <>
                                                <Typography className="description" variant="body2">
                                                    {artist.description}
                                                </Typography>
                                                <div className="social-icons column-icons">
                                                    <a
                                                        href={artist.links.spotify || "#"}
                                                        target="_blank"
                                                        rel="noreferrer">
                                                        <img src={spotifyIcon} alt="Spotify" />
                                                    </a>
                                                    <a
                                                        href={artist.links.instagram || "#"}
                                                        target="_blank"
                                                        rel="noreferrer">
                                                        <img src={instagramIcon} alt="Instagram" />
                                                    </a>
                                                    <a
                                                        href={artist.links.facebook || "#"}
                                                        target="_blank"
                                                        rel="noreferrer">
                                                        <img src={facebookIcon} alt="Facebook" />
                                                    </a>
                                                    <a
                                                        href={artist.links.youtube || "#"}
                                                        target="_blank"
                                                        rel="noreferrer">
                                                        <img src={youtubeIcon} alt="YouTube" />
                                                    </a>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Typography className="read-more-hint" variant="body2">
                                                    Click here for Read more
                                                </Typography>
                                                <div className="social-icons row-icons">
                                                    <img src={spotifyIcon} alt="Spotify" />
                                                    <img src={instagramIcon} alt="Instagram" />
                                                    <img src={facebookIcon} alt="Facebook" />
                                                    <img src={youtubeIcon} alt="YouTube" />
                                                </div>
                                            </>
                                        )}
                                    </CardContent>
                                </div>
                            </Card>
                        </div>
                    ))}
                </div>
            </Container>
        </div>
    );
}

export default SellYourMusicThirdSection;
